import { usePartVehicleApplications } from '@/core/domain/operational/PartVehicleApplications/PartVehicleApplications.hooks';
import { PartVehicleApplication } from '@/core/domain/operational/PartVehicleApplications/PartVehicleApplications.types';
import { getTableScrollX } from '@/utils/table';
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useIntl } from 'react-intl';
import { useRouteMatch } from 'react-router-dom';

const ApplicationsList = () => {
  const intl = useIntl().formatMessage;
  const { partId } = useRouteMatch<{ partId: string }>().params;

  const { data, isLoading } = usePartVehicleApplications(+partId);

  const columns: ColumnsType<PartVehicleApplication> = [
    {
      dataIndex: ['modelDTO', 'brand', 'name'],
      title: intl({ id: 'parts.application.modal.form.brand' }),
      ellipsis: true,
      width: 220,
    },
    {
      dataIndex: ['modelDTO', 'name'],
      title: intl({ id: 'parts.application.modal.form.model' }),
      ellipsis: true,
      width: 220,
    },

    {
      dataIndex: 'fromYear',
      title: intl({
        id: 'parts.application.modal.form.fromYear',
      }),
      ellipsis: true,
      width: 140,
    },
    {
      dataIndex: 'toYear',
      title: intl({ id: 'parts.application.modal.form.toYear' }),
      ellipsis: true,
      width: 140,
    },
  ];

  return (
    <Table
      loading={isLoading}
      pagination={false}
      dataSource={data?.data}
      columns={columns}
      scroll={{ x: getTableScrollX(columns) }}
    />
  );
};

export default ApplicationsList;
